/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Camera_Switch_HintInputs */

const th_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนกล้องจะทำให้การถ่ายทอดหยุดชั่วครู่`)
};

const en_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changing cameras briefly interrupts the broadcast.`)
};

const ja_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラの切り替え中は配信が一時的に途切れます。`)
};

const zh_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换摄像头会短暂中断直播。`)
};

const es_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar de cámara interrumpe brevemente la retransmisión.`)
};

const pt_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar de câmera interrompe a transmissão por um instante.`)
};

const id_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengganti kamera memutus siaran sebentar.`)
};

const fr_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de caméra interrompt brièvement la diffusion.`)
};

const tl_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandaling naaantala ang sahimpapawid kapag nagpalit ng camera.`)
};

const vi_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi máy ảnh sẽ ngắt buổi phát trong chốc lát.`)
};

const ko_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라를 바꾸면 중계가 잠시 끊깁니다.`)
};

const de_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Kamerawechsel unterbricht die Übertragung kurz.`)
};

const ru_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смена камеры ненадолго прерывает трансляцию.`)
};

const tr_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera değiştirmek yayını kısa süre keser.`)
};

const it_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiare fotocamera interrompe brevemente la trasmissione.`)
};

const pl_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana kamery na chwilę przerywa transmisję.`)
};

const uk_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна камери ненадовго перериває трансляцію.`)
};

const hi_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैमरा बदलने पर प्रसारण थोड़ी देर रुकता है।`)
};

const ar_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل الكاميرا يقطع البث للحظة.`)
};

const ms_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menukar kamera memutuskan siaran seketika.`)
};

const bn_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা বদলালে সম্প্রচার কিছুক্ষণ থেমে যায়।`)
};

const zh_tw2_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換相機會短暫中斷轉播。`)
};

const zh_hk2_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換相機會短暫中斷轉播。`)
};

const ur_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیمرا بدلنے سے نشریات لمحہ بھر رک جاتی ہیں۔`)
};

const fa_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعویض دوربین پخش را لحظه‌ای قطع می‌کند.`)
};

const sw_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kubadili kamera kunakatiza urushaji kwa muda mfupi.`)
};

const nl_video_camera_switch_hint = /** @type {(inputs: Video_Camera_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van camera wisselen onderbreekt de uitzending even.`)
};

/**
* | output |
* | --- |
* | "Changing cameras briefly interrupts the broadcast." |
*
* @param {Video_Camera_Switch_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera_switch_hint = /** @type {((inputs?: Video_Camera_Switch_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Camera_Switch_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera_switch_hint(inputs)
	if (locale === "ja") return ja_video_camera_switch_hint(inputs)
	if (locale === "zh") return zh_video_camera_switch_hint(inputs)
	if (locale === "es") return es_video_camera_switch_hint(inputs)
	if (locale === "pt") return pt_video_camera_switch_hint(inputs)
	if (locale === "id") return id_video_camera_switch_hint(inputs)
	if (locale === "fr") return fr_video_camera_switch_hint(inputs)
	if (locale === "tl") return tl_video_camera_switch_hint(inputs)
	if (locale === "vi") return vi_video_camera_switch_hint(inputs)
	if (locale === "ko") return ko_video_camera_switch_hint(inputs)
	if (locale === "de") return de_video_camera_switch_hint(inputs)
	if (locale === "ru") return ru_video_camera_switch_hint(inputs)
	if (locale === "tr") return tr_video_camera_switch_hint(inputs)
	if (locale === "it") return it_video_camera_switch_hint(inputs)
	if (locale === "pl") return pl_video_camera_switch_hint(inputs)
	if (locale === "uk") return uk_video_camera_switch_hint(inputs)
	if (locale === "hi") return hi_video_camera_switch_hint(inputs)
	if (locale === "ar") return ar_video_camera_switch_hint(inputs)
	if (locale === "ms") return ms_video_camera_switch_hint(inputs)
	if (locale === "bn") return bn_video_camera_switch_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera_switch_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera_switch_hint(inputs)
	if (locale === "ur") return ur_video_camera_switch_hint(inputs)
	if (locale === "fa") return fa_video_camera_switch_hint(inputs)
	if (locale === "sw") return sw_video_camera_switch_hint(inputs)
	if (locale === "nl") return nl_video_camera_switch_hint(inputs)
	return en_video_camera_switch_hint(inputs)
});